<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		style="fill: currentColor"
	>
		<g data-name="vuesax/bold/trash">
			<path
				d="M18.824 3.98c-1.61-.16-3.22-.28-4.84-.37V3.6l-.22-1.3c-.15-.92-.37-2.3-2.71-2.3h-2.62C6.1 0 5.884 1.32 5.724 2.29l-.21 1.28c-.93.06-1.86.12-2.79.21l-2.04.2a.748.748 0 1 0 .14 1.49l2.04-.2a79.729 79.729 0 0 1 15.82.21h.08a.757.757 0 0 0 .75-.68.766.766 0 0 0-.69-.82z"
				transform="translate(2.246 1.25)"
				style="fill: currenColor"
			/>
			<path
				data-name="Vector"
				d="M14.8.39a1.264 1.264 0 0 0-.91-.39H1.252a1.248 1.248 0 0 0-.91.39A1.288 1.288 0 0 0 0 1.33l.62 10.26c.11 1.52.25 3.42 3.74 3.42h6.42c3.49 0 3.63-1.89 3.74-3.42l.62-10.25a1.3 1.3 0 0 0-.34-.95zM9.232 10H5.9a.75.75 0 0 1 0-1.5h3.33a.75.75 0 0 1 0 1.5zm.84-4h-5a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 0 1.5z"
				transform="translate(4.428 7.75)"
				style="fill: currentColor"
			/>
		</g>
	</svg>
</template>
